export default "__VITE_ASSET__UOdESGtO__"